import { Chip, Paper, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import useDrivers from "../services/useDrivers";

const columns = [
  { field: "user_id", headerName: "ID", width: 70 },

  { field: "email", headerName: "Email", flex: 1, minWidth: 180 },

  { field: "phone", headerName: "Phone", flex: 0.8, minWidth: 140 },

  { field: "status", headerName: "Status", flex: 0.8, minWidth: 130 },

  {
    field: "is_online",
    headerName: "Online",
    width: 110,
    renderCell: ({ value }) => (
      <Chip size="small" label={value ? "Online" : "Offline"} color={value ? "success" : "default"} />
    ),
  },

  {
    field: "viva_kyc_status",
    headerName: "KYC",
    width: 110,
    renderCell: ({ value }) => (
      <Chip
        size="small"
        label={value || "pending"}
        color={value === "verified" ? "success" : value === "rejected" ? "error" : "warning"}
      />
    ),
  },

  {
    field: "is_active",
    headerName: "Active",
    width: 110,
    renderCell: ({ value }) => (
      <Chip size="small" label={value ? "Active" : "Inactive"} color={value ? "success" : "default"} />
    ),
  },

  { field: "rating", headerName: "Rating", width: 90 },

  { field: "vehicle", headerName: "Vehicle", flex: 1, minWidth: 160 },
];

export default function DriversPage() {
  const { drivers, loading } = useDrivers();

  const rows = drivers.map((driver) => ({
    id: driver.user_id,
    user_id: driver.user_id,
    email: driver.user?.email || "-",
    phone: driver.user?.phone || "-",
    status: driver.status,
    is_online: driver.is_online,
    viva_kyc_status: driver.viva_kyc_status,
    is_active: driver.is_active,
    rating: driver.rating,
    vehicle: driver.vehicle_model || (driver.vehicle ? `${driver.vehicle.make} ${driver.vehicle.model}` : "-"),
  }));

  return (
    <Stack spacing={2}>
      <Typography variant="h4" fontWeight={700}>
        Drivers
      </Typography>
      <Paper sx={{ height: 560, borderRadius: 3, overflow: "hidden" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          loading={loading}
          pageSizeOptions={[10, 25, 50]}
          disableRowSelectionOnClick
          density="compact"
          sx={{
            fontSize: 13,
            "& .MuiDataGrid-cell": {
              py: 0.5,
            },
          }}
        />
      </Paper>
    </Stack>
  );
}
